import { DatePipe } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild, HostListener, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BnLoadingService, EntityOrderedRequestParameters, EntityPagedResult } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnUsuarioService } from "@bndes/bndes-ux4/bn-usuario";
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ROLE_AGENTE_CONSULTA, ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA } from 'src/app/constantes/permissao.constants';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Dominio } from 'src/app/model/dominio-operacao.model';
import { EstadoOperacao } from 'src/app/model/dominio-operacao.model';
import Utils from 'src/app/shared/fgi-utils';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { OperacaoCreditoLivre } from '../../../model/operacao-credito-livre.model';
import { OperacaoGarantida, TIPOS_OPERACAO } from '../../../model/operacao-garantida.model';
import { BotoesExportacaoOperacaoService } from './botoes-exportacao-operacao.service';
import { ListaOperacoesService } from './lista-operacoes.service';
import { LIMITE_OPERACOES_EXPORTADAS, OperacaoGarantidaService } from './operacao-garantida.service';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { ModalidadeService } from '../../../shared/services/modalidade.service';
import { LimiteAdicionalService } from 'src/app/features/limite-adicional/limite-adicional.service';

const LIMITE_EXPORTACAO_CSV = LIMITE_OPERACOES_EXPORTADAS; // Limita a quantidade de operações a ser exportada nos botões.

@Component({
    selector: 'app-operacao-pesquisa',
    templateUrl: './operacao-pesquisa.component.html',
    styleUrls: ['./operacao-pesquisa.component.scss'],
    standalone: false
})
export class OperacaoPesquisaComponent implements OnInit {

  @ViewChild(BnConfirmDirective, { static: false }) vc: BnConfirmDirective;
  @ViewChild('meuId', { static: false }) botoesPersonalizados: TemplateRef<any>;

  private podeCriarOperacao = false; // usado no html
  private podeEscolherAgente: boolean;
  private ehAgenteFinanceiro: boolean;
  private contemFiltroPesquisaAnterior = false;
  private pesquisaAvancada: boolean = false;

  private tranches: Tranche[];
  private operacoes: OperacaoGarantida[];

  private agenteFinanceiroSelecionado: AgenteFinanceiro;
  private agentesFinanceiros: AgenteFinanceiro[] = [];
  private estados: EstadoOperacao[] = [];
  
  cnpjUsuario: string;
  tiposOperacao = TIPOS_OPERACAO;

  private CODIGO_REPASSE_BNDES = 'R';
  private CODIGO_CREDITO_LIVRE = 'L';

  public dadosDominio: Dominio;

  // modelo do formulario
  private agenteFinanceiro: AgenteFinanceiro;
  private idOperacao: number;
  private idExternoOperacao: string;
  private dataContratacaoInicial: Date;
  private dataContratacaoFinal: Date;
  private dataEnvioInicial: Date;
  private dataEnvioFinal: Date;
  private estado: EstadoOperacao;
  private tipoOperacao: string;
  private ideTranche: number;
  private sistema: string;
  private contrato: number;
  private idModalidadeOperacao: string;
  private cpfOuCnpjBeneficiario: string;

  private atributosPaginacaoComponenteListagem: EntityPagedResult<OperacaoCreditoLivre>;
  private opcoesPaginacao: number[];

  private pesquisado: boolean; // usado no html

  private pesquisaForm: UntypedFormGroup;
  private valoresPesquisaForm: any;

  private limitesAdicionais: any[] = [];
  private idLimiteAdicional: number;

  private totalObjetosRetornados: number;

  private ordenacaoAtual: EntityOrderedRequestParameters = { atributo: '', sentido: 'asc' };
  private readonly ORDENACAO_PADRAO: EntityOrderedRequestParameters = { atributo: 'dataEnvio', sentido: 'desc' };

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: OperacaoGarantidaService,
    private listaOperacoesService: ListaOperacoesService,
    private bnAlertsService: BnAlertsService,
    private datePipe: DatePipe,
    private botoesExportacaoOperacaoService: BotoesExportacaoOperacaoService,
    private router: Router,
    private permissaoService: PermissaoService,
    private bnUsuarioService: BnUsuarioService,
    private activatedRoute: ActivatedRoute,
    private fileUtils: FileUtilsService,
    private trancheService: TrancheService,
    private limiteAdicionalService: LimiteAdicionalService,
    private modalidadeService: ModalidadeService,) {
  }

  @HostListener('window:keydown.enter', ['$event'])
  keyEvent(event: KeyboardEvent) {
    this.buscar(false, true, true)
  }

  ngOnInit() {
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1,
      pageSize: this.opcoesPaginacao[0],
      pages: undefined,
      count: undefined,
      list: undefined
    };

    //this.desabilitarCamposPesquisa();

    this.dadosDominio = this.activatedRoute.snapshot.data['dominios'];
    if (this.estaVindoDaTelaDeDetalhes()) {
      //  this.recuperarFiltrosUltimaPesquisaRealizada();
    }

    this.trancheService.getTranches().subscribe(tranches => {
      this.tranches = tranches;
    });

    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.podeEscolherAgente = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeCriarOperacao = resp && resp[ROLE_AGENTE_ENVIO];
      this.ehAgenteFinanceiro = resp && resp[ROLE_AGENTE_CONSULTA];
    });

    this.bnUsuarioService.usuario$.subscribe(usuario => {
      this.cnpjUsuario = usuario && usuario.cnpj;
    });

    this.pesquisado = undefined;

    // resolver
    this.agentesFinanceiros = this.activatedRoute.snapshot.data['agentes'];
    this.estados = this.activatedRoute.snapshot.data['dominios'].estadosOperacao
      .filter((estado: EstadoOperacao) => estado.id !== 12);  // issue 366: remover estado "em gravação" do filtro
    this.construirFormulario();
  }

  private construirFormulario() {
    this.valoresPesquisaForm = JSON.parse(sessionStorage.getItem('valoresPesquisaForm'));
    this.pesquisaForm = this.formBuilder.group({
      agenteFinanceiro: [this.valoresPesquisaForm ? this.valoresPesquisaForm.agenteFinanceiro : ''],
      tipoOperacao: [this.valoresPesquisaForm ? this.valoresPesquisaForm.tipoOperacao : ''],
      ideTranche: [this.valoresPesquisaForm ? this.valoresPesquisaForm.ideTranche : ''],
      idOperacao: [this.valoresPesquisaForm ? this.valoresPesquisaForm.idOperacao : '', [Validators.pattern(/^[0-9]+$/), Validators.minLength(1), Validators.maxLength(9999999999999)]],
      idExternoOperacao: [this.valoresPesquisaForm ? this.valoresPesquisaForm.idExternoOperacao : '', [Validators.pattern(/^[A-Za-z0-9_\-]+$/), Validators.minLength(1), Validators.maxLength(20)]],
      sistema: [this.valoresPesquisaForm ? this.valoresPesquisaForm.sistema : ''],
      contrato: [this.valoresPesquisaForm ? this.valoresPesquisaForm.contrato : '', [Validators.pattern(/^[0-9]+$/), Validators.minLength(11), Validators.maxLength(11)]],
      estado: [this.valoresPesquisaForm ? this.valoresPesquisaForm.estado : ''],
      dataContratacaoInicial: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataContratacaoInicial : null, []],
      dataContratacaoFinal: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataContratacaoFinal : null, []],
      dataEnvioInicial: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataEnvioInicial : null, []],
      dataEnvioFinal: [this.valoresPesquisaForm ? this.valoresPesquisaForm.dataEnvioFinal : null, []],
      idModalidadeOperacao: [this.valoresPesquisaForm ? this.valoresPesquisaForm.idModalidadeOperacao : ''],
      idLimiteAdicional: [this.valoresPesquisaForm ? this.valoresPesquisaForm.idLimiteAdicional : ''],
      cpfOuCnpjBeneficiario: [this.valoresPesquisaForm ? this.valoresPesquisaForm.cpfOuCnpjBeneficiario : '', [Validators.pattern(/^[0-9]+$/), Validators.minLength(8), Validators.maxLength(14)]],
    });
    this.pesquisaForm.valueChanges.pipe().subscribe(novosValores => {
      this.valoresPesquisaForm = novosValores;
      sessionStorage.setItem('valoresPesquisaForm', JSON.stringify(this.valoresPesquisaForm));
    });
    this.incluirValidacoesAdicionais();
    

  }
  

  private aplicarOrdenacaoEBuscar(ord: EntityOrderedRequestParameters) {
    this.ordenacaoAtual = { ...ord };
    this.buscar(false, true, false);
  }

  private incluirValidacoesAdicionais() {
    const campoModalidadeOperacao = this.pesquisaForm.get("idModalidadeOperacao");
    const campoSistema =  this.pesquisaForm.get('sistema');
    const campoContrato = this.pesquisaForm.get('contrato');
    const campoLimiteAdicional = this.pesquisaForm.get('idLimiteAdicional');

    //Verificando sessionStorage
    if(this.valoresPesquisaForm){
      if (this.valoresPesquisaForm.tipoOperacao === this.CODIGO_CREDITO_LIVRE) {
        campoSistema.disable();
        campoSistema.reset();
        campoContrato.disable();
        campoContrato.reset();

      } 
      if ( this.valoresPesquisaForm.tipoOperacao === this.CODIGO_REPASSE_BNDES){
        campoModalidadeOperacao.disable();
        campoModalidadeOperacao.reset();
      }
      if( this.valoresPesquisaForm.dataContratacaoFinal&&  this.valoresPesquisaForm.dataContratacaoInicial && this.valoresPesquisaForm.dataContratacaoFinal <= this.valoresPesquisaForm.dataContratacaoInicial){
        this.bnAlertsService.alertaErro('Erro', 'A data de contratação final não pode ser menor ou igual do que a inicial.');
        this.pesquisaForm.get('dataContratacaoFinal').setErrors({ 'incorrect': true });
      }
    }


    this.pesquisaForm.get('dataContratacaoFinal').valueChanges.subscribe(data => {
      {
  
        const dataContratacaoInicial = this.datePipe.transform(this.pesquisaForm.get('dataContratacaoInicial').value, 'yyyyMMdd');
        const dataContratacaoFinal = this.datePipe.transform(data, 'yyyyMMdd');

        if (data && dataContratacaoInicial) {
          if(dataContratacaoFinal <= dataContratacaoInicial){
          this.bnAlertsService.alertaErro('Erro', 'A data de contratação final não pode ser menor ou igual do que a inicial.');
          this.pesquisaForm.get('dataContratacaoFinal').setErrors({ 'incorrect': true });
          }
        } else {
          this.pesquisaForm.get('dataContratacaoFinal').clearValidators();
          this.pesquisaForm.get('dataContratacaoInicial').clearValidators();
        }
      }
    });

    this.pesquisaForm.get('tipoOperacao').valueChanges.subscribe(tipo => {
      if (tipo === this.CODIGO_CREDITO_LIVRE) {
        campoModalidadeOperacao.enable();
        campoSistema.disable();
        campoSistema.reset();
        campoContrato.disable();
        campoContrato.reset();

        campoLimiteAdicional.disable();
        campoLimiteAdicional.reset();
      }
      else if (tipo === this.CODIGO_REPASSE_BNDES) {
        campoSistema.enable();
        campoContrato.enable();
        campoModalidadeOperacao.disable();
        campoModalidadeOperacao.reset();

        campoLimiteAdicional.enable();
        this.carregarLimitesAdicionais();
      }
      else {
        campoModalidadeOperacao.enable();
        campoSistema.enable();
        campoContrato.enable();

        campoLimiteAdicional.disable();
        campoLimiteAdicional.reset();
      }
    });

    if (this.pesquisaForm.get('tipoOperacao').value === this.CODIGO_REPASSE_BNDES) {
      campoLimiteAdicional.enable();
      this.carregarLimitesAdicionais();
    } else {
      campoLimiteAdicional.disable();
    }
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.pesquisaForm.pristine) {
      return true;
    } else {
      // map necessario porque bnConfirm retorna string e nao boolean
      return this.verificaSePodeSair().pipe(map(res => res === 'ok'));
    }
  }

  verificaSePodeSair(): Observable<string> {
    this.vc.abrirModal();
    return this.vc.resultadoConfirm.asObservable();
  }

  mudancaPagina(novaPagina: EntityPagedResult<OperacaoCreditoLivre>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false, false);
  }

  atribuiAgenteFinanceiroSelecionado(nomeAgenteFinanceiro) {
    if (nomeAgenteFinanceiro) {
      this.agenteFinanceiroSelecionado = this.agentesFinanceiros.filter(agente => agente.nome === nomeAgenteFinanceiro)[0];
    }
    else {
      this.agenteFinanceiroSelecionado = undefined;
    }
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean, ordenacaoPadrao: boolean) {
    this.loadingService.bloqueiaTela();

    if (ordenacaoPadrao) {
      this.ordenacaoAtual = { ...this.ORDENACAO_PADRAO };
    }
    
    const params: any = this.getParams();

    if (voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(this.operacoes, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }

    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;
    
    this.service.getOperacoes(params)
      .subscribe(response => {
        this.pesquisado = false;
        this.operacoes = response ? response.resultados : undefined;
        this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
        this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
        this.pesquisado = true;
       

        this.loadingService.liberaTela();

        paginaVazia = Utils.verificaPaginaVazia(this.operacoes, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
        if (paginaVazia && !voltarPagina1) {
          this.buscar(false, true, ordenacaoPadrao);
        }
      });
      
  }

  getParams(comDetalhes?: boolean): any {

    const params: any = {};
    //    const form = this.pesquisaForm.getRawValue();

    if (this.ordenacaoAtual?.atributo) {
      params.orderBy = this.ordenacaoAtual.atributo;
      params.sentidoOrderBy = this.ordenacaoAtual.sentido;
    }

    this.idOperacao = this.pesquisaForm.get('idOperacao').value;
    this.idExternoOperacao = this.pesquisaForm.get('idExternoOperacao').value;
    this.sistema = this.pesquisaForm.get('sistema').value;
    this.contrato = this.pesquisaForm.get('contrato').value;
    this.dataContratacaoInicial = this.pesquisaForm.get('dataContratacaoInicial').value;
    this.dataContratacaoFinal = this.pesquisaForm.get('dataContratacaoFinal').value;
    this.dataEnvioInicial = this.pesquisaForm.get('dataEnvioInicial').value;
    this.dataEnvioFinal = this.pesquisaForm.get('dataEnvioFinal').value;
    this.tipoOperacao = this.pesquisaForm.get('tipoOperacao').value;
    this.ideTranche = this.pesquisaForm.get('ideTranche').value;
    this.idModalidadeOperacao = this.pesquisaForm.get('idModalidadeOperacao').value;
    this.cpfOuCnpjBeneficiario = this.pesquisaForm.get('cpfOuCnpjBeneficiario').value;
    this.idLimiteAdicional = this.pesquisaForm.get('idLimiteAdicional').value;

    const nomeAgenteFinanceiro = this.pesquisaForm.get('agenteFinanceiro').value;
    if (this.podeEscolherAgente) {
      this.agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.nome === nomeAgenteFinanceiro)[0];
    }
    else {
      this.agenteFinanceiro = this.agentesFinanceiros.filter(agente => agente.cnpj === this.cnpjUsuario)[0];
    }

    if (this.tipoOperacao) {
      params.tipoOpe = this.tipoOperacao;
    }

    if (this.ideTranche) {
      params.ideTranche = this.ideTranche;
    }

    const nomeEstado = this.pesquisaForm.get('estado').value;
    this.estado = this.estados.filter(estado => estado.nome === nomeEstado)[0];

    if (this.idOperacao) {
      params.idOperacao = this.idOperacao;
    }

    if (this.idExternoOperacao) {
      params.idExternoOperacao = this.idExternoOperacao;
    }

    if (this.sistema) {
      params.sistema = this.sistema;
    }

    if (this.contrato) {
      params.contrato = this.contrato;
    }

    if (this.agenteFinanceiro) {
      params.cnpjAgenteFinanceiro = this.agenteFinanceiro.cnpj;
    }

    if (this.dataContratacaoInicial) {
      params.dataContratacaoInicial = this.datePipe.transform(this.dataContratacaoInicial, 'yyyyMMdd');
    }

    if (this.dataContratacaoFinal) {
      params.dataContratacaoFinal = this.datePipe.transform(this.dataContratacaoFinal, 'yyyyMMdd');
    }

    if (this.dataEnvioInicial) {
      params.dataEnvioInicial = this.datePipe.transform(this.dataEnvioInicial, 'yyyyMMdd');
    }

    if (this.dataEnvioFinal) {
      params.dataEnvioFinal = this.datePipe.transform(this.dataEnvioFinal, 'yyyyMMdd');
    }

    if (this.estado) {
      params.idEstado = this.estado.id;
    }

    if (this.idModalidadeOperacao) {
      params.idModalidadeOperacao = this.idModalidadeOperacao;
    }    

    if (this.cpfOuCnpjBeneficiario) {
      params.cpfOuCnpjBeneficiario = this.cpfOuCnpjBeneficiario;
    }

    if (comDetalhes) {
      params.comDetalhes = true;
      params.limite = LIMITE_EXPORTACAO_CSV;
      params.pagina = 1;
    }

    if (this.idLimiteAdicional) {
      params.idLimiteAdicional = this.idLimiteAdicional;
    }

    return params;
  }


  exportarAditivos() {
    this.loadingService.bloqueiaTela();
    this.service.getOperacoes(this.getParams(true))
      .subscribe(resp => this.botoesExportacaoOperacaoService.exportarAditivos(resp));
  }

  exportarOperacoes() {
    this.loadingService.bloqueiaTela();
    this.service.getOperacoes(this.getParams(true)).subscribe((resp) => {
      this.botoesExportacaoOperacaoService.exportarOperacoes(this.modalidadeService.getModalidades(), resp);
    });
  }

  exportarLiberacoes() {
    this.loadingService.bloqueiaTela();
    this.service.getOperacoes(this.getParams(true))
      .subscribe(resp => this.botoesExportacaoOperacaoService.exportarLiberacoes(resp));
  }

  exportarAmortizacoes() {
    this.loadingService.bloqueiaTela();
    this.service.getOperacoes(this.getParams(true))
      .subscribe(resp => this.botoesExportacaoOperacaoService.exportarAmortizacoes(resp));
  }

  compararPorId(item1: string, item2: string): boolean {

    if (item1 && item2) {
      return item1 === item2;
    }
    if (!item1 && !item2) {
      return true;
    }
    return false;
  }

  limpar() {

    this.agenteFinanceiro = undefined;
    this.estado = undefined;
    this.tipoOperacao = undefined;
    this.ideTranche = undefined;
    this.sistema = undefined;
    this.contrato = undefined;
    this.idOperacao = undefined;
    this.idExternoOperacao = undefined;
    this.dataContratacaoInicial = undefined;
    this.dataContratacaoFinal = undefined;
    this.dataEnvioInicial = undefined;
    this.dataEnvioFinal = undefined;
    this.idModalidadeOperacao = undefined;
    this.cpfOuCnpjBeneficiario = undefined;
    this.operacoes = [];

    this.pesquisado = undefined;

    this.pesquisaForm.reset();
    this.pesquisaForm.get('agenteFinanceiro').setValue(undefined);
    this.pesquisaForm.get('tipoOperacao').setValue(undefined);
    this.pesquisaForm.get('ideTranche').setValue(undefined);
    this.pesquisaForm.get('sistema').setValue(undefined);
    this.pesquisaForm.get('contrato').setValue(undefined);
    this.pesquisaForm.get('estado').setValue(undefined);
    this.pesquisaForm.get('idModalidadeOperacao').setValue(undefined);
    this.pesquisaForm.get('cpfOuCnpjBeneficiario').setValue(undefined);
    this.pesquisaForm.updateValueAndValidity();
    this.idLimiteAdicional = undefined;
    this.limitesAdicionais = [];
    this.pesquisaForm.get('idLimiteAdicional').setValue(undefined);
  }

  habilitarCamposPesquisa() {
    this.pesquisaForm.get('agenteFinanceiro').enable();
    this.pesquisaForm.get('tipoOperacao').enable();
    this.pesquisaForm.get('ideTranche').enable();
    this.pesquisaForm.get('sistema').enable();
    this.pesquisaForm.get('contrato').enable();
    this.pesquisaForm.get('estado').enable();
    this.pesquisaForm.get('idOperacao').enable();
    this.pesquisaForm.get('idExternoOperacao').enable();
    this.pesquisaForm.get('dataContratacaoInicial').enable();
    this.pesquisaForm.get('dataContratacaoFinal').enable();
    this.pesquisaForm.get('idModalidadeOperacao').enable();
    this.pesquisaForm.get('cpfOuCnpjBeneficiario').enable();
  }

  desabilitarCamposPesquisa() {
    this.pesquisaForm.get('agenteFinanceiro').disable();
    this.pesquisaForm.get('tipoOperacao').disable();
    this.pesquisaForm.get('ideTranche').disable();
    this.pesquisaForm.get('sistema').disable();
    this.pesquisaForm.get('contrato').disable();
    this.pesquisaForm.get('estado').disable();
    this.pesquisaForm.get('idOperacao').disable();
    this.pesquisaForm.get('idExternoOperacao').disable();
    this.pesquisaForm.get('dataContratacaoInicial').disable();
    this.pesquisaForm.get('dataContratacaoFinal').disable();
    this.pesquisaForm.get('idModalidadeOperacao').disable();
    this.pesquisaForm.get('cpfOuCnpjBeneficiario').disable();
    this.pesquisaForm.get('idLimiteAdicional').disable();
  }

  estaVindoDaTelaDeDetalhes(): boolean {
    return Boolean(this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state);
  }

  togglePesquisaAvancada() {
    this.pesquisaAvancada = !this.pesquisaAvancada;
  }

  private carregarLimitesAdicionais() {
    this.limiteAdicionalService.buscarLimitesAdicionaisPorModalidade().subscribe((limites: any[]) => {
      this.limitesAdicionais = limites || [];
    });
  }

}

